import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconBrandGoogle } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useGoogleFontsSettings } from 'pages/revisions-module/template-editor/editors/visual/typography/GoogleFontsSettingsProvider';

/**
 * Control used to load Google fonts into the template editor visual settings.
 */
export default function GoogleFonts({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();
  const { openGoogleFontsSettings } = useGoogleFontsSettings();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconBrandGoogle />}
      label="Pridať Google Font"
      onClick={() => openGoogleFontsSettings({ onClose: () => editor?.chain().focus().run() })}
    />
  );
}
